import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function imageTextAnimations() {
  document.addEventListener("DOMContentLoaded", () => {
    const sections = document.querySelectorAll(".image-text .elements-box");
    if (!sections.length) return;

    sections.forEach(box => {
      const cols = box.querySelectorAll(".col-12, .col-11, .col-lg-5, .col-lg-6, [class*='col-']");
      if (!cols.length) return;

      gsap.set(cols, { opacity: 0, willChange: "opacity" });

      gsap.to(cols, {
        opacity: 1,
        duration: 0.9,
        ease: "power2.out",
        stagger: 0.15,
        scrollTrigger: {
          trigger: box,
          start: "top 75%",
          toggleActions: "play none none none",
          once: true
        },
        onComplete() {
          gsap.set(cols, { willChange: "auto" });
        }
      });
    });
  });
}